import { InputType } from "@app/enum/input-type";
import { QuestionBase } from "../question-base";

export class CheckboxQuestion extends QuestionBase<string> {
  override type = InputType.CHECK;
}